
import Event = createjs.Event;

export class Poker2TutorialEvent extends Event {
    public static TUTORIAL_STATE_CHANGE: string = "tutorialstatechange";
    public static TUTORIAL_REWARD: string = "tutorialReward";
    public static TUTORIAL_STATE_UNLOCKALL: string = "tutorialUnlockAll";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}
